<template>
  <v-dialog
      v-model="scanner_active"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
          dark
          color="primary"
      >
        <v-spacer></v-spacer>
        <v-toolbar-title>{{ overlay_title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            dark
            @click="userCanceled"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row
            align="center"
            class="mx-0"
        >
          <SharedQrCodeScannerComponent
              :displayExitBtnOnError="true"
              :errorBtnText="$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.manual_btn')"
              @decodedQr="validateRiskReflexQRCode"
              @closedScannerError="closeWithError"
              @criticalError="scanner_has_critical_error = $event">
          </SharedQrCodeScannerComponent>
        </v-row>

        <v-row v-if="!scanner_has_critical_error"
               align="center"
               class="mx-0">
          <v-col cols="12" class=" text-center">
            <p style="font-size: 12px;" class="text-center">
              {{ $vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.info_manual') }}</p><!--  -->
            <v-btn text dark small
                   style="text-decoration: underline; font-size: 12px;color:rgba(0, 0, 0, 0.6);text-transform: none;"
                   @click="userCanceled">
              {{ $vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.manual_btn') }}
            </v-btn>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
    <simple-popup-component
        :is-visible="display_scan_error"
        :title="error_title"
        :body="error_body"
        @positive_btn_clicked="closeWithError"
    ></simple-popup-component>
  </v-dialog>
</template>

<script>
import SimplePopupComponent from "@/components/modules/global/simplePopup/SimplePopupComponent";
import SharedQrCodeScannerComponent from "@/components/modules/qrCodeScanner/SharedQrCodeScannerComponent";
import appSettings from "@/mixins/config/appSettings";
import {RRQrCodeReturnTypeGlobalProject} from "@/helpers/RiskReflexQRCodeHelpers/RiskReflexQRCodeReturnTypes";

export default {
  name: "RiskReflexQRCodesScannerOverlayComponent",
  components: {SimplePopupComponent, SharedQrCodeScannerComponent},
  props: {
    scanner_active: {
      type: Boolean,
      default: false
    },
    acceptedQrCodeReturnTypes: {
      type: Array
    }
  },
  data() {
    return {
      overlay_title: '',
      scanner_has_critical_error: false,
      display_scan_error: false,
      error_title: '',
      error_body: '',
    }
  },
  methods: {
    userCanceled() {
      if (this.scanner_has_critical_error) {
        this.closeWithError();
      } else {
        this.$emit('userCanceled');
      }
    },
    validateRiskReflexQRCode($data) {
      try {
        let $parsedData = JSON.parse($data);
        if (
            ('qrt' in $parsedData && $parsedData.qrt !== null) &&
            ('tnnt' in $parsedData && $parsedData.tnnt !== null)
        ) {
          if (this.acceptedQrCodeReturnTypes.length !== 0) {
            if (!this.acceptedQrCodeReturnTypes.includes($parsedData.qrt)) {
              this.displayScanError('wrong_qr_code_type');
              return;
            }
          }
          if ($parsedData.tnnt != this.appSettings.LAASTenantID) {
            this.displayScanError('wrong_tenant');
            return;
          }

          if(!this.isValidDataForRRQRCodeType($parsedData, $parsedData.qrt)){
            this.displayScanError('invalid_qr_data');
            return;
          }
          this.$emit('successfullyValidatedRRQR', $parsedData);

        } else {
          this.displayScanError('invalid_qr_code');
          return;
        }
      } catch (e) {
        this.displayScanError('invalid_qr_code');
        return;
      }
    },
    displayScanError($errorType) {
      switch ($errorType) {
        case 'wrong_qr_code_type':
          this.error_title = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.wrong_qr_code_type.title');
          this.error_body = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.wrong_qr_code_type.body');
          break;
        case 'wrong_tenant':
          this.error_title = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.wrong_tenant.title');
          this.error_body = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.wrong_tenant.body');
          break;
        case 'invalid_qr_code':
          this.error_title = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.invalid_qr_code.title');
          this.error_body = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.invalid_qr_code.body');
          break;
        case 'invalid_qr_data':
          this.error_title = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.invalid_qr_data.title');
          this.error_body = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.errors.invalid_qr_data.body');
          break;
        default:
          break;
      }
      this.display_scan_error = true;
    },
    isValidDataForRRQRCodeType($QRCodeData, $RRQRCodeType){
      var $valid = false;
      switch ($RRQRCodeType){
        case RRQrCodeReturnTypeGlobalProject:
          $valid = this.validateGlobalProjectQRCode($QRCodeData);
          break;
      }
      return $valid;
    },
    validateGlobalProjectQRCode($QRCodeData){
      if($QRCodeData.qrt === RRQrCodeReturnTypeGlobalProject && ('proj' in $QRCodeData) && typeof $QRCodeData.proj === 'number'){
        return true
      }
      return false;
    },
    closeWithError() {
      this.display_scan_error = false
      this.$emit('closedWithError');
    },
  },
  mounted() {
    this.overlay_title = this.$vuetify.lang.t('$vuetify.risk_reflex_qr_code_scanner.overlay_view.title');
  },
  mixins: [appSettings]
}
</script>

<style scoped>

</style>